import React, { InputHTMLAttributes, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons/faEyeSlash';

import '../i18n/config';

export type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const PasswordInput = ({ className, ...rest }: PasswordInputProps): JSX.Element => {
  const { t } = useTranslation('translation');
  const [visible, setVisible] = useState(false);

  return (
    <div className={`flex items-center ${className ?? 'w-full'}`}>
      <input
        {...rest}
        type={visible ? 'text' : 'password'}
        className='flex-1 min-w-0 bg-transparent border-0 p-0 placeholder-gray-500 sm:text-sm focus:ring-0 focus:outline-none'
      />
      <button
        type='button'
        aria-label={visible
          ? t('components.passwordInput.hidePassword')
          : t('components.passwordInput.showPassword')}
        title={t('components.passwordInput.seePassword')}
        onClick={(): void => setVisible((prev) => !prev)}
        className='shrink-0 ml-2 flex items-center bg-transparent border-0 p-0 m-0 cursor-pointer text-gray-500 hover:text-sapphire'
      >
        <FontAwesomeIcon icon={visible ? faEyeSlash : faEye} />
      </button>
    </div>
  );
};
